<div>
  <p-fieldset legend="Avsluta medlemskap i Storlogen">
    <form [formGroup]="terminatemembershipstorlogeform">
      <div class="form-group">
        <label>Medlem</label>
        <div>{{memberid}} {{givenname}} {{familyname}}</div>
      </div>
      <div class="form-group">
        <label for="fromDate">Från datum</label>
        <app-calendar [form]="terminatemembershipstorlogeform" formName="fromDate" [required]=true></app-calendar>
      </div>
      <fieldset class="border p-2">
        <legend class="w-auto" style="font-size:14px;">Orsak</legend>
        <br>
        <mat-radio-group formControlName="gott" required>
          <div>
            <mat-radio-button value=12>Avsluta medlemskap i Storlogen</mat-radio-button>
          </div>
        </mat-radio-group>
      </fieldset>
      <br>
    </form>

    <div class="d-flex justify-content-start">
      <button class="btn border" (click)="save()" [disabled]="!terminatemembershipstorlogeform.valid">Avsluta medlemskapet</button>
      <button class="btn border" (click)="close()">Avbryt</button>
    </div>

  </p-fieldset>
</div>